<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-h6">Objetivos Periódicos (Estratégicos)</span>
            <v-spacer></v-spacer>
            <v-btn
              color="orange"
              dark
              class="mr-2"
              @click="abrirDialogoAgregar"
              small
              tile
              v-if="tienePermisos"
            >
              <v-icon left small>mdi-plus</v-icon>
              Agregar Objetivo
            </v-btn>
            <v-btn
              color="primary"
              dark
              @click="initialize"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>

          <!-- KPI Cards: Resumen Empresarial -->
          <v-card-text class="pb-0">
            <v-row dense>
              <v-col cols="12" md="3">
                <v-card outlined class="pa-2 text-center" color="blue lighten-5">
                  <div class="text-caption grey--text text-uppercase font-weight-bold">Total Objetivos</div>
                  <div class="text-h5 primary--text font-weight-bold">{{ objetivos.length }}</div>
                </v-card>
              </v-col>
              <v-col cols="12" md="3">
                <v-card outlined class="pa-2 text-center" color="green lighten-5">
                  <div class="text-caption grey--text text-uppercase font-weight-bold">Avance Promedio</div>
                  <div class="text-h5 success--text font-weight-bold">{{ promedioAvance }}%</div>
                </v-card>
              </v-col>
              <v-col cols="12" md="3">
                <v-card outlined class="pa-2 text-center" color="orange lighten-5">
                  <div class="text-caption grey--text text-uppercase font-weight-bold">En Proceso</div>
                  <div class="text-h5 orange--text font-weight-bold">{{ resumenEstatus.en_proceso.cantidad }}</div>
                </v-card>
              </v-col>
              <v-col cols="12" md="3">
                <v-card outlined class="pa-2 text-center" color="grey lighten-4">
                  <div class="text-caption grey--text text-uppercase font-weight-bold">Completados</div>
                  <div class="text-h5 grey--text text-darken-3 font-weight-bold">{{ resumenEstatus.completado.cantidad }}</div>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>

          <!-- Sección de Gráficos Circulares (amcharts5) -->
          <v-card-text v-show="objetivos.length > 0">
            <v-row align="center" justify="center">
              <v-col cols="12" md="10">
                <div id="chartdiv" style="width: 100%; height: 280px; margin: auto;"></div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-text>
            <!-- Tabs Tipo de Objetivo -->
            <v-tabs v-model="tabTipo" color="deep-purple accent-4" class="mb-4">
              <v-tab><v-icon left small>mdi-domain</v-icon>Empresa</v-tab>
              <v-tab><v-icon left small>mdi-account-group</v-icon>Departamentos</v-tab>
            </v-tabs>

            <!-- Tabs Periodicidad -->
            <v-tabs v-model="tabPeriodicidad" color="primary" dense class="mb-4">
              <v-tab>Anual</v-tab>
              <v-tab>Trimestral</v-tab>
              <v-tab>Mensual</v-tab>
            </v-tabs>

            <!-- Filtros -->
            <v-row dense class="mb-4">
              <v-col cols="12" md="2">
                <v-select
                  v-model="anio"
                  :items="anios"
                  label="Año"
                  dense
                  filled
                  hide-details
                  @change="initialize"
                ></v-select>
              </v-col>

              <v-col cols="12" md="2" v-if="tabPeriodicidad === 1"> <!-- Trimestral -->
                <v-select
                  v-model="periodo"
                  :items="trimestres"
                  label="Trimestre"
                  dense
                  filled
                  hide-details
                  @change="initialize"
                ></v-select>
              </v-col>

              <v-col cols="12" md="2" v-if="tabPeriodicidad === 2"> <!-- Mensual -->
                <v-select
                  v-model="periodo"
                  :items="meses"
                  label="Mes"
                  dense
                  filled
                  hide-details
                  @change="initialize"
                ></v-select>
              </v-col>

              <v-col cols="12" md="4" v-if="tabTipo === 1">
                <v-autocomplete
                  v-model="id_departamento"
                  :items="departamentos"
                  item-text="departamento"
                  item-value="iddepartamento"
                  label="Selecciona Departamento"
                  dense
                  filled
                  hide-details
                  clearable
                  @change="initialize"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <!-- Tabla de Datos Profesional con Expansión -->
            <v-data-table
              :headers="headers"
              :items="objetivosPrincipales"
              :loading="cargando"
              class="elevation-0"
              dense
              :show-expand="tabPeriodicidad < 2"
              single-expand
            >
              <template v-slot:item.objetivo="{ item }">
                <div class="d-flex align-center">
                  <v-icon small class="mr-2" color="primary" v-if="tieneHijos(item.id)">mdi-family-tree</v-icon>
                  <span class="font-weight-medium">{{ item.objetivo }}</span>
                </div>
              </template>

              <template v-slot:item.progreso="{ item }">
                <div class="d-flex align-center" style="min-width: 120px;">
                  <v-progress-linear
                    :value="item.progreso"
                    :color="getColorProgreso(item.progreso)"
                    height="8"
                    rounded
                    class="flex-grow-1"
                  ></v-progress-linear>
                  <span class="ml-2 text-caption font-weight-bold">{{ item.progreso }}%</span>
                </div>
              </template>

              <template v-slot:item.estatus="{ item }">
                <v-chip
                  x-small
                  :color="getColorEstatus(item.estatus)"
                  dark
                  label
                  style="font-size: 0.65rem;"
                >
                  {{ item.estatus.toUpperCase().replace('_', ' ') }}
                </v-chip>
              </template>

              <template v-slot:item.actions="{ item }">
                <div class="d-flex justify-end">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon x-small color="primary" v-bind="attrs" v-on="on" @click="editarItem(item)" v-if="tienePermisos">
                        <v-icon small>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar Objetivo</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon x-small color="error" v-bind="attrs" v-on="on" @click="confirmarEliminar(item)" v-if="tienePermisos">
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Eliminar Objetivo</span>
                  </v-tooltip>
                </div>
              </template>

              <!-- Slot de Expansión (Árbol de Objetivos Hijos) -->
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="grey lighten-5 pa-4">
                  <div class="text-subtitle-2 blue--text mb-2 d-flex align-center">
                    <v-icon left color="blue">mdi-layers-triple</v-icon>
                    Objetivos Hijos Vinculados
                  </div>
                  <v-data-table
                    :headers="headersHijos"
                    :items="getHijos(item.id)"
                    hide-default-footer
                    dense
                    class="elevation-1 rounded"
                    v-if="tieneHijos(item.id)"
                  >
                    <template v-slot:item.progreso="{ item }">
                      <v-progress-linear :value="item.progreso" :color="getColorProgreso(item.progreso)" height="5" rounded></v-progress-linear>
                    </template>
                    <template v-slot:item.estatus="{ item }">
                      <v-chip x-small :color="getColorEstatus(item.estatus)" dark outlined label>{{ item.estatus.toUpperCase().replace('_', ' ') }}</v-chip>
                    </template>
                  </v-data-table>
                  <v-alert dense text type="info" v-else class="text-caption mb-0">
                    No hay objetivos hijos vinculados directamente a este elemento.
                  </v-alert>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Diálogo Agregar/Editar Diseño Profesional -->
    <v-dialog v-model="dialog" max-width="800px" persistent>
      <v-card class="rounded-lg overflow-hidden">
        <v-toolbar color="primary" dark flat dense>
          <v-toolbar-title class="text-subtitle-1">
            <v-icon left>mdi-bullseye-arrow</v-icon>
            {{ formTitle }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon small @click="cerrar"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>

        <v-card-text class="pt-6">
          <v-container>
            <v-form ref="formObjetivo">
              <!-- Sección: Información Base -->
              <div class="text-subtitle-2 grey--text text-uppercase mb-4 d-flex align-center">
                <v-icon small left color="primary">mdi-information</v-icon>
                Información del Objetivo
              </div>
              <v-row dense>
                <v-col cols="12">
                  <v-textarea
                    v-model="editedItem.objetivo"
                    label="Descripción del Objetivo Estratégico"
                    placeholder="Escribe el objetivo de forma clara y concisa..."
                    filled
                    auto-grow
                    rows="2"
                    counter="250"
                    persistent-hint
                    prepend-inner-icon="mdi-text-box-edit"
                  ></v-textarea>
                </v-col>
                
                <v-col cols="12">
                  <v-textarea
                    v-model="editedItem.metrica"
                    label="Métrica de Seguimiento y Éxito"
                    placeholder="Ej: Lograr un incremento del 20% en..."
                    filled
                    auto-grow
                    rows="2"
                    prepend-inner-icon="mdi-finance"
                  ></v-textarea>
                </v-col>
              </v-row>

              <v-divider class="my-4"></v-divider>

              <!-- Sección: Planificación y Fechas -->
              <div class="text-subtitle-2 grey--text text-uppercase mb-4 d-flex align-center">
                <v-icon small left color="primary">mdi-calendar-clock</v-icon>
                Planificación del Periodo
              </div>
              
              <v-row dense>
                <v-col cols="12" md="6" v-if="tabPeriodicidad === 1">
                  <v-select
                    v-model="editedItem.periodo"
                    :items="trimestres"
                    label="Asignar Trimestre"
                    filled
                    prepend-inner-icon="mdi-numeric-1-box"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6" v-if="tabPeriodicidad === 2">
                  <v-select
                    v-model="editedItem.periodo"
                    :items="meses"
                    label="Asignar Mes"
                    filled
                    prepend-inner-icon="mdi-calendar-month"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6" v-if="rangoFechasLectura">
                  <v-text-field
                    label="Vigencia del Periodo"
                    :value="rangoFechasLectura"
                    filled
                    readonly
                    background-color="blue-grey lighten-5"
                    prepend-inner-icon="mdi-calendar-check"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" v-if="tabTipo === 1"> <!-- Departamento -->
                  <v-autocomplete
                    v-model="editedItem.id_departamento"
                    :items="departamentos"
                    item-text="departamento"
                    item-value="iddepartamento"
                    label="Departamento Responsable"
                    filled
                    prepend-inner-icon="mdi-account-group"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6" v-if="tabPeriodicidad > 0">
                  <v-select
                    v-model="editedItem.id_padre"
                    :items="posiblesPadres"
                    item-text="objetivo"
                    item-value="id"
                    label="Vincular a Objetivo Superior"
                    filled
                    clearable
                    prepend-inner-icon="mdi-link-variant"
                  >
                    <template v-slot:prepend-inner>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon small color="blue" v-bind="attrs" v-on="on" class="mr-1">mdi-help-circle-outline</v-icon>
                        </template>
                        <span>Relaciona este objetivo a un nivel estratégico superior (ej: de Mensual a Anual)</span>
                      </v-tooltip>
                    </template>
                  </v-select>
                </v-col>
              </v-row>

              <v-divider class="my-4"></v-divider>

              <!-- Sección: Seguimiento de Avance -->
              <div class="text-subtitle-2 grey--text text-uppercase mb-2 d-flex align-center">
                <v-icon small left color="primary">mdi-trending-up</v-icon>
                Avance y Estatus
              </div>

              <v-row dense align="center">
                <v-col cols="12" md="8">
                  <div class="d-flex justify-space-between align-center px-1">
                    <span class="text-caption font-weight-bold">Progreso Actual: {{ editedItem.progreso }}%</span>
                  </div>
                  <v-slider
                    v-model="editedItem.progreso"
                    thumb-label
                    ticks
                    min="0"
                    max="100"
                    color="primary"
                    track-color="grey lighten-2"
                    class="mt-2"
                  ></v-slider>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="editedItem.estatus"
                    :items="['pendiente', 'en_proceso', 'completado', 'cancelado']"
                    label="Estatus Actual"
                    filled
                    hide-details
                    class="rounded-lg"
                    :color="getColorEstatus(editedItem.estatus)"
                  >
                    <template v-slot:item="{ item }">
                      <v-chip :color="getColorEstatus(item)" x-small dark label>{{ item.toUpperCase() }}</v-chip>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              
              <v-alert dense type="info" text icon="mdi-lightbulb-on" class="text-caption mt-4 mb-0">
                El estatus se ajustará automáticamente según el progreso, a menos que elijas "Cancelado".
              </v-alert>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions class="pa-4 grey lighten-5">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text class="text-capitalize" @click="cerrar">Cancelar</v-btn>
          <v-btn color="primary" class="text-capitalize px-6 shadow" @click="guardar" :loading="guardando">
            Confirmar Objetivo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo Confirmar Eliminar -->
    <v-dialog v-model="dialogDelete" max-width="400px">
      <v-card>
        <v-card-title class="text-h6">¿Eliminar objetivo?</v-card-title>
        <v-card-text>Esta acción no se puede deshacer de forma sencilla.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" text @click="dialogDelete = false">Cancelar</v-btn>
          <v-btn color="error" @click="eliminarConfirmar">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametrosAlerta" />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Alerta from '@/components/alertas/Alerta.vue';
import validarErrores from '@/mixins/validarErrores';
import * as am5 from '@amcharts/amcharts5';
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import moment from 'moment';

export default {
  mixins: [validarErrores],
  components: { Alerta },
  data: () => ({
    tabTipo: 0, // 0: Empresa, 1: Departamento
    tabPeriodicidad: 0, // 0: Anual, 1: Trimestral, 2: Mensual
    anio: new Date().getFullYear(),
    periodo: null,
    id_departamento: null,
    
    objetivos: [],
    departamentos: [],
    posiblesPadres: [],
    cargando: false,
    guardando: false,

    dialog: false,
    dialogDelete: false,
    editedIndex: -1,

    editedItem: {
      id: null,
      objetivo: '',
      id_departamento: null,
      id_padre: null,
      progreso: 0,
      estatus: 'pendiente',
      anualidad: null,
      periodo: null,
      metrica: '',
      anualidad: null,
      periodo: null,
      tipo_objetivo: '',
      periodicidad: ''
    },
    defaultItem: {
      id: null,
      objetivo: '',
      metrica: '',
      id_departamento: null,
      id_padre: null,
      progreso: 0,
      estatus: 'pendiente'
    },
    
    // amcharts
    root: null,

    anios: [2024, 2025, 2026],
    trimestres: [
      { text: 'T1 (Ene-Mar)', value: 1 },
      { text: 'T2 (Abr-Jun)', value: 2 },
      { text: 'T3 (Jul-Sep)', value: 3 },
      { text: 'T4 (Oct-Dic)', value: 4 }
    ],
    meses: [
      { text: 'Enero', value: 1 }, { text: 'Febrero', value: 2 }, { text: 'Marzo', value: 3 },
      { text: 'Abril', value: 4 }, { text: 'Mayo', value: 5 }, { text: 'Junio', value: 6 },
      { text: 'Julio', value: 7 }, { text: 'Agosto', value: 8 }, { text: 'Septiembre', value: 9 },
      { text: 'Octubre', value: 10 }, { text: 'Noviembre', value: 11 }, { text: 'Diciembre', value: 12 }
    ],

    // Alertas
    respuestaAlerta: false,
    parametrosAlerta: {
      dialogError: false,
      mensaje: '',
      color: 'success'
    },

    PUESTOS_AUTORIZADOS: [11, 12, 40, 54, 56, 68, 107, 43, 72]
  }),

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
    
    formTitle() {
      return this.editedIndex === -1 ? 'Nuevo Objetivo' : 'Editar Objetivo';
    },

    tienePermisos() {
      const idpuesto = this.getdatosUsuarioERPERP ? this.getdatosUsuarioERPERP.idpuesto : null;
      return this.PUESTOS_AUTORIZADOS.includes(parseInt(idpuesto));
    },

    headers() {
      const h = [
        { text: 'Objetivo', value: 'objetivo', width: '35%' },
        { text: 'Métrica de Seguimiento', value: 'metrica', width: '25%' },
        { text: 'Progreso', value: 'progreso', align: 'center', width: '15%' },
        { text: 'Estatus', value: 'estatus', align: 'center', width: '10%' },
        { text: 'Vinculado', value: 'id_padre', width: '10%' },
        { text: '', value: 'actions', sortable: false, align: 'end', width: '5%' }
      ];
      if (this.tabTipo === 1) h.splice(4, 0, { text: 'Dep.', value: 'nombre_departamento', width: '10%' });
      
      // Solo agregar la columna de expansión si no es la pestaña mensual
      if (this.tabPeriodicidad < 2) {
        h.push({ text: '', value: 'data-table-expand', align: 'end' });
      }
      
      return h;
    },

    headersHijos() {
      return [
        { text: 'Objetivo Hijo', value: 'objetivo' },
        { text: 'Avance', value: 'progreso', width: '150px' },
        { text: 'Estatus', value: 'estatus', align: 'center' }
      ];
    },

    objetivosPrincipales() {
      const periodicidadDeseada = this.tabPeriodicidad === 0 ? 'anual' : (this.tabPeriodicidad === 1 ? 'trimestral' : 'mensual');
      // Filtramos por la periodicidad de la pestaña para que no desaparezcan al vincularlos
      return this.objetivos.filter(o => o.periodicidad === periodicidadDeseada);
    },

    promedioAvance() {
      if (this.objetivos.length === 0) return 0;
      const sum = this.objetivos.reduce((acc, curr) => acc + parseInt(curr.progreso || 0), 0);
      return Math.round(sum / this.objetivos.length);
    },

    resumenEstatus() {
      // Inicializar todos los estados posibles para evitar errores de 'undefined' en el render
      const resumen = {
        pendiente: { cantidad: 0, nombres: [] },
        en_proceso: { cantidad: 0, nombres: [] },
        completado: { cantidad: 0, nombres: [] },
        cancelado: { cantidad: 0, nombres: [] }
      };

      this.objetivos.forEach(o => {
        if (resumen[o.estatus]) {
          resumen[o.estatus].cantidad++;
          resumen[o.estatus].nombres.push(`• ${o.objetivo}`);
        }
      });
      return resumen;
    },

    rangoFechasLectura() {
      if (!this.editedItem.periodo) return '';
      const year = this.anio;
      if (this.tabPeriodicidad === 1) { // Trimestre
        const t = this.editedItem.periodo;
        const start = moment(`${year}-${(t - 1) * 3 + 1}-01`, 'YYYY-M-DD').format('DD/MM/YYYY');
        const end = moment(`${year}-${t * 3}-01`, 'YYYY-M-DD').endOf('month').format('DD/MM/YYYY');
        return `${start} - ${end}`;
      } else if (this.tabPeriodicidad === 2) { // Mes
        const m = this.editedItem.periodo;
        const start = moment(`${year}-${m}-01`, 'YYYY-M-DD').format('DD/MM/YYYY');
        const end = moment(`${year}-${m}-01`, 'YYYY-M-DD').endOf('month').format('DD/MM/YYYY');
        return `${start} - ${end}`;
      }
      return '';
    }
  },

  watch: {
    tabTipo() { this.initialize(); },
    tabPeriodicidad() { this.initialize(); },
    dialog(val) { val || this.cerrar(); },
    'editedItem.progreso'(val) {
      if (!this.dialog || this.editedIndex === -1 && val === 0) return; // Evitar disparos innecesarios al abrir nuevo
      if (this.editedItem.estatus === 'cancelado') return;
      
      const p = parseInt(val);
      if (p === 100) this.editedItem.estatus = 'completado';
      else if (p > 0) this.editedItem.estatus = 'en_proceso';
      else if (p === 0) this.editedItem.estatus = 'pendiente';
    }
  },

  async created() {
    await this.getDepartamentos();
    await this.initialize();
  },

  methods: {
    async initialize() {
      this.cargando = true;
      try {
        const params = {
          tipo_objetivo: this.tabTipo === 0 ? 'empresa' : 'departamento',
          // Quitamos periodicidad y periodo del filtro base para traer todo el árbol del año
          anualidad: this.anio,
          id_departamento: this.id_departamento
        };

        const { data } = await this.$http.get('objetivos.periodicos.get', { params });
        this.objetivos = data;
        
        this.$nextTick(() => {
          this.generarGrafica();
        });
      } catch (e) {
        let mensaje = (e.response && e.response.data && e.response.data.message) ? e.response.data.message : 'Error al cargar objetivos';
        this.mostrarAlerta(mensaje, 'error');
      } finally {
        this.cargando = false;
      }
    },

    generarGrafica() {
      if (this.root) {
        this.root.dispose();
      }

      const div = document.getElementById('chartdiv');
      if (!div || this.objetivos.length === 0) return;

      this.root = am5.Root.new("chartdiv");
      this.root.setThemes([am5themes_Animated.new(this.root)]);

      let chart = this.root.container.children.push(
        am5percent.PieChart.new(this.root, {
          layout: this.root.verticalHorizontal,
          innerRadius: am5.percent(50)
        })
      );

      let series = chart.series.push(
        am5percent.PieSeries.new(this.root, {
          valueField: "cantidad",
          categoryField: "estatus",
          alignLabels: false
        })
      );

      // series.labels.template.setAll({ templateField: "settings" });
      // series.ticks.template.setAll({ templateField: "settings" });

      series.slices.template.setAll({
        templateField: "sliceSettings",
        strokeOpacity: 0
      });

      // Mapeo de datos para el Pie Chart con identificación de objetivos (filtrando vacíos)
      const chartData = Object.keys(this.resumenEstatus)
        .map(key => ({
          estatus: key.toUpperCase().replace('_', ' '),
          cantidad: this.resumenEstatus[key].cantidad,
          objetivosList: this.resumenEstatus[key].nombres.join('\n'),
          sliceSettings: { fill: am5.color(this.getColorHex(key)) }
        }))
        .filter(item => item.cantidad > 0);

      series.data.setAll(chartData);

      series.slices.template.set("tooltipText", "{category}: {value} objetivos\n[fontSize: 12px]{objetivosList}[/]");

      let legend = chart.children.push(am5.Legend.new(this.root, {
        centerX: am5.percent(50),
        x: am5.percent(50),
        marginTop: 15,
        marginBottom: 15
      }));

      // Corregir acceso a markers y template
      if (legend.markers) {
        legend.markers.template.setAll({ 
          cornerRadiusL: 2, 
          cornerRadiusR: 2, 
          cornerRadiusT: 2, 
          cornerRadiusB: 2 
        });
      }

      legend.data.setAll(series.dataItems);

      series.appear(1000, 100);
      chart.appear(1000, 100);
    },

    getColorHex(s) {
      const colors = {
        pendiente: '#9E9E9E',
        en_proceso: '#2196F3',
        completado: '#4CAF50',
        cancelado: '#F44336'
      };
      return colors[s] || '#9E9E9E';
    },

    tieneHijos(id) {
      return this.objetivos.some(o => o.id_padre === id);
    },

    getHijos(id) {
      return this.objetivos.filter(o => o.id_padre == id);
    },

    async getDepartamentos() {
      try {
        const { data } = await this.$http.get('objetivos.periodicos.departamentos');
        this.departamentos = data;
      } catch (e) { console.error(e); }
    },

    async fetchPosiblesPadres() {
      try {
        const tipo = this.tabTipo === 0 ? 'empresa' : 'departamento';
        const { data } = await this.$http.get('objetivos.periodicos.posiblesPadres', {
          params: { anualidad: this.anio, tipo }
        });
        this.posiblesPadres = data;
      } catch (e) { console.error(e); }
    },

    abrirDialogoAgregar() {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.fetchPosiblesPadres();
      this.dialog = true;
    },

    editarItem(item) {
      this.editedIndex = this.objetivos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.fetchPosiblesPadres();
      this.dialog = true;
    },

    confirmarEliminar(item) {
      this.editedIndex = this.objetivos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async eliminarConfirmar() {
      try {
        const idpuesto = this.getdatosUsuarioERPERP ? this.getdatosUsuarioERPERP.idpuesto : null;
        await this.$http.delete(`objetivos.periodicos.delete/${this.editedItem.id}`, { data: { idpuesto } });
        this.mostrarAlerta('Objetivo eliminado', 'success');
        this.initialize();
      } catch (e) {
        let mensaje = (e.response && e.response.data && e.response.data.message) ? e.response.data.message : 'Error al eliminar';
        this.mostrarAlerta(mensaje, 'error');
      } finally {
        this.dialogDelete = false;
      }
    },

    cerrar() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async guardar() {
      this.guardando = true;
      try {
        const idpuesto = this.getdatosUsuarioERPERP ? this.getdatosUsuarioERPERP.idpuesto : null;
        const payload = {
          ...this.editedItem,
          idpuesto,
          tipo_objetivo: this.tabTipo === 0 ? 'empresa' : 'departamento',
          periodicidad: this.tabPeriodicidad === 0 ? 'anual' : (this.tabPeriodicidad === 1 ? 'trimestral' : 'mensual'),
          anualidad: this.anio,
          periodo: this.periodo,
          id_usuario_responsable: this.getdatosUsuarioERPERP ? this.getdatosUsuarioERPERP.iderp : null
        };

        if (this.editedIndex > -1) {
          await this.$http.put(`objetivos.periodicos.update/${this.editedItem.id}`, payload);
        } else {
          await this.$http.post('objetivos.periodicos.add', payload);
        }
        this.mostrarAlerta('Guardado correctamente', 'success');
        this.initialize();
        this.cerrar();
      } catch (e) {
        let mensaje = (e.response && e.response.data && e.response.data.message) ? e.response.data.message : 'Error al guardar';
        this.mostrarAlerta(mensaje, 'error');
      } finally {
        this.guardando = false;
      }
    },

    getColorProgreso(p) {
      if (p <= 33) return 'red';
      if (p <= 80) return 'orange';
      return 'green';
    },

    getColorEstatus(s) {
      const colors = {
        pendiente: 'grey',
        en_proceso: 'blue',
        completado: 'green',
        cancelado: 'error'
      };
      return colors[s] || 'grey';
    },

    mostrarAlerta(mensaje, color) {
      this.parametrosAlerta = { mensaje, color, dialogError: true };
      this.respuestaAlerta = true;
    }
  }
};
</script>

<style scoped>
.shadowCard {
  box-shadow: 0 4px 15px rgba(0,0,0,0.1) !important;
  border-radius: 8px;
}
</style>
